import NotificationMiddle from "./NotificationMiddle";

export default NotificationMiddle;